import React from 'react';
import {Grid, Header} from 'semantic-ui-react';
import {ISOToDisplayDate} from 'common/utils';
import {COMMENT_TYPE} from 'app-ui-componentlibrary/dist/common/constants';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import REST from 'go/requests/rest';
import _ from 'lodash';

export class CommentList extends React.Component {
  state = {};

  renderTask(task) {
    const {entityType} = this.props;
    const USER_COMMENT =
      entityType === 'rfa'
        ? `Additional comment to the request for assistance`
        : `Additional comment to the ${
            entityType === 'subGrant' ? 'subgrant' : 'grant'
          } file`;

    if (task == null) {
      return <Grid.Column width={16}>{USER_COMMENT}</Grid.Column>;
    } else {
      return <Grid.Column width={16}>Task: {_.startCase(task)}</Grid.Column>;
    }
  }

  buildUserIdNameMap() {
    const {comments, token} = this.props;
    const uniqueUserIds = _.uniq(_.map(comments, (comment) => comment.author));

    let userIdPayload = {
      userId: uniqueUserIds,
    };

    REST.user
      .getProfilesForUsers(token, userIdPayload)
      .then((response) => response.json())
      .then((data) => {
        if (!_.isNull(data)) {
          const authorMap = {};
          _.forEach(
            data,
            (user) => (authorMap[user.userId] = `${user.firstName} ${user.lastName}`)
          );

          this.setState({
            authorMap,
          });
        }
      });
  }

  componentDidMount() {
    if (this.props.comments !== undefined) {
      this.buildUserIdNameMap();
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.comments, this.props.comments)) {
      this.buildUserIdNameMap();
    }
  }

  renderComment(commentObj) {
    const {comment, subject, author, task, entryDate, internalOnly} = commentObj;
    const {authorMap} = this.state;
    // NOTE, fallback defaults haven't been approved by anyone.
    // These would be malformed comments and shouldn't exist.
    const commentType = internalOnly ? COMMENT_TYPE.INTERNAL : COMMENT_TYPE.EXTERNAL;

    const authorName = _.get(authorMap, author, author) || 'Comment author not found';
    const commSubj = subject || 'No Subject';
    const commText = comment || 'No comment left';
    const timezoneConfig = {
      describeMonth: true,
      showHours: true,
      showDate: true,
    };
    return (
      <Grid.Row className="comment">
        <div className="comment__date-row">
          {ISOToDisplayDate(entryDate, timezoneConfig)}
        </div>
        <Grid.Column width={16}>
          <Header as="h5">{commSubj}</Header>
          {commText}
        </Grid.Column>
        <Grid.Column width={16} className="comment__author-row">
          - {authorName}
        </Grid.Column>

        <Grid.Column width={16}>
          <Grid padded="vertically">
            <Grid.Row>
              {this.renderTask(task)}
              <Grid.Column width={12}>{commentType}</Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid.Row>
    );
  }

  render() {
    const {comments} = this.props;
    return (
      <Grid>
        {_.map(comments, (comment) => {
          if (comment !== false) {
            return this.renderComment(comment);
          }
        })}
      </Grid>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    token: _.get(state, 'auth.token'),
  };
};

export default connect(mapStateToProps)(connectDynamic(CommentList));
